import { Controller } from "@hotwired/stimulus";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "../react/App";

export default class extends Controller {
  static targets = ["mount"];

  connect() {
    const el = this.mountTarget;
    const props = JSON.parse(el.getAttribute("data-props") || "{}");
    this.root = createRoot(el);
    this.root.render(<App {...props} />);
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
    this.root = null;
  }
}
